module.exports = __webpack_public_path__ + "static/media/bird.6cf79660.png";